var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01506 16.0029H11.0151M7.01506 11.0049H15.0151M10.0151 21.9999H11.0151M7.51106 21.9999C6.34106 21.9749 5.54106 21.8999 4.76506 21.6749C3.71506 21.3999 2.95006 20.4749 2.72506 19.1759C2.44006 17.9519 2.54006 14.9289 2.51506 11.3299C2.51706 8.53892 2.39006 5.85792 2.84006 4.33392C3.11506 3.83392 3.34006 2.00992 7.06506 2.03392C7.69006 2.00992 14.3151 1.95992 15.3651 2.05992C18.8651 2.13492 19.2151 3.93392 19.4151 5.63292C19.5421 6.88292 19.5151 8.88092 19.5151 11.0049M7.01506 2.00992C7.31506 3.63392 7.29006 4.68392 8.39006 4.93292C8.86506 5.00792 9.95006 5.00592 11.1151 5.00792C12.1551 5.00992 13.2151 5.01992 13.6901 4.90792C14.8651 4.63392 14.7401 3.18392 15.0401 2.00992M18.2801 14.3789C16.9051 15.7789 14.2571 18.2769 14.2571 18.4519C14.0441 18.7489 13.8571 19.3519 13.7331 20.2019C13.5761 20.9889 13.3881 21.6749 13.6081 21.8749C13.8281 22.0749 14.6551 21.9069 15.5311 21.7249C16.2311 21.6499 16.8811 21.3999 17.2051 21.1509C17.6801 20.7309 20.9031 17.4769 21.2771 17.0529C21.5521 16.6779 21.5771 15.9779 21.3371 15.5529C21.2031 15.2529 20.3531 14.4529 20.0781 14.2289C19.8015 14.0584 19.4776 13.9809 19.1539 14.0079C18.8301 14.0349 18.5245 14.1649 18.2801 14.3789Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.4aa543376ce6b2375053709d0250e820.svg";
export { ForwardRef as ReactComponent };